
import { useEffect, useState } from 'react';
import { CloseButtonModal } from './CloseButtonModal';
import { UserProfileData } from './common-components/UserProfileData';
import { UserContactData } from './common-components/UserContactData';
import logger from '../../../../../utils/logger';
import { div, p } from 'framer-motion/client';
import { CustomFormFloating } from '../../../custom-form-floating/CustomFormFloating';


export const KitShipping = ({ toggleModal, isActive = false, userData }, component) => {

  const [editInput, setEditInput] = useState(true)

  const editionEnable = () => {
    setEditInput(false)
  };

  const editionDisable = () => {
    setEditInput(true)
  };

  useEffect(() => {

    if (isActive) {
      //? Se desactiva la edicion al cambiar de ventana dentro del modal
      editionDisable()
    }
  }, [isActive])

  logger.debug('Kit userData: ', userData?.kitDeliveries[0])



  const kit = userData?.kitDeliveries && userData.kitDeliveries.length > 0 ? userData.kitDeliveries[0] : null;
  const hasEnrollment = !!userData?.yearOfEnrollment;


 

  const renderContent = () => {
    //?  Si ya realizó la formación  yearOfEnrollment != null
    if (hasEnrollment) {
      return (
        <div className='user-dto '>
          <div className="retirement-tpa">
            <p className="p-store-title d-flex align-item-center">No Aplica</p>
          </div>
        </div>

      );
    }

    //?  Si no tiene kitDelivery (Formulario con guiones)
    if (!kit) {
      return (
        <div className="user-dto d-flex ud-scroll flex-column">
        <CustomFormFloating status={editInput} type="text" label="Dirección" value={'---'}>
          <p className="dto-title-1">Dirección</p>
          <span className="editable-1">-</span>
          <hr className="hr-dto" />
        </CustomFormFloating>

        <CustomFormFloating status={editInput} type="text" label="Código Postal" value={ '---'}>
          <p className="dto-title-1">Código Postal</p>
          <span className="editable-1">-</span>
          <hr className="hr-dto" />
        </CustomFormFloating>

        <CustomFormFloating status={editInput} type="text" label="Localidad" value={ '---'}>
          <p className="dto-title-1">Localidad</p>
          <span className="editable-1">-</span>
          <hr className="hr-dto" />
        </CustomFormFloating>

        <CustomFormFloating status={editInput} type="text" label="Localidad" value={ '---'}>
          <p className="dto-title-1">Provincia</p>
          <span className="editable-1">-</span>
          <hr className="hr-dto" />
        </CustomFormFloating>
      </div>
      );
    }

    //? Si es Pickup === true (Retiro presencial)
    if (kit.pickup) {
      return (
        <div className="retirement-tpa">
          <div className="iRetirement-container">
            <span className="material-symbols-outlined notranslate mI-subscription">store</span>
          </div>
          <div className="store-container">
            <p className="p-store-title">Retiro por Instituto Vianett® en Córdoba Capital</p>
            <hr />
            <p className="p-store">Cosquín 1222, X5000 Córdoba</p>
          </div>
        </div>
      );
    }

    //? Si Pickup === false (Envío a domicilio)
    return (
      <div className="user-dto d-flex ud-scroll flex-column">
        <CustomFormFloating status={editInput} type="text" label="Dirección" value={kit.address || '---'}>
          <p className="dto-title-1">Dirección</p>
          <span className="editable-1">{kit.address || '-'}</span>
          <hr className="hr-dto" />
        </CustomFormFloating>

        <CustomFormFloating status={editInput} type="text" label="Código Postal" value={kit.zipCode || '---'}>
          <p className="dto-title-1">Código Postal</p>
          <span className="editable-1">{kit.zipCode || '-'}</span>
          <hr className="hr-dto" />
        </CustomFormFloating>

        <CustomFormFloating status={editInput} type="text" label="Código Postal" value={kit.addressAdditionalData || '---'}>
          <p className="dto-title-1">Información adicional (Barrio, Piso, Dpto, etc)</p>
          <span className="editable-1">{kit.addressAdditionalData || '-'}</span>
          <hr className="hr-dto" />
        </CustomFormFloating>

        <CustomFormFloating status={editInput} type="text" label="Localidad" value={kit.city || '---'}>
          <p className="dto-title-1">Localidad</p>
          <span className="editable-1">{kit.city || '-'}</span>
          <hr className="hr-dto" />
        </CustomFormFloating>

        <CustomFormFloating status={editInput} type="text" label="Localidad" value={kit.province || '---'}>
          <p className="dto-title-1">Provincia</p>
          <span className="editable-1">{kit.province || '-'}</span>
          <hr className="hr-dto" />
        </CustomFormFloating>
      </div>
    );
  };

  return (
    <div id="content-2" className={`dto-contacto content ${isActive ? 'active' : ''}`}>
      <CloseButtonModal toggleModal={toggleModal} />

      <div className="header-dto">
        <h4 className="header-nav-title">Envío de Kit</h4>
        <UserProfileData userInfo={userData} />
        <UserContactData userInfo={userData} />
      </div>

      <hr className="under-header" />


      {renderContent()}

    </div>
  );
}
